<template>
  <list-template
    :search-config="searchConfig"
    :table-config="tableConfig"
    :table-data="tableData"
    :total="total"
    :loading="loading"
    :current-page="page"
    @onHandle="handleClick"
    @onExportData="handDownload"
    @onSearch="onSearch"
    @onReset="onReset"
    @onChangePage="handleCurrentChange"
    @onChange="onChange"
  >
  </list-template>
</template>

<script>
import { tableListMixin } from '@/utils/mixins'
import { setConfigOption } from '@/utils'
import { fileDownload, getAllUnDeleteGrade, getActualSchool } from '@/api'
export default {
  _config:{'route':{'path':'list','meta':{'title':'列表','keepAlive':true}}},
  mixins: [tableListMixin],
  data() {
    return {
      searchConfig: [
        { placeholder: '搜索学生姓名', prop: 'student_name' },
        { placeholder: '筛选缴费状态', prop: 'pay_status', tag: 'select', options: [
          { label: '未缴费', value: 0 },
          { label: '已缴费', value: 1 }
        ] },
        { placeholder: '筛选报名校区', prop: 'school_id', tag: 'select', options: [] },
        { placeholder: '筛选入学年级', prop: 'grade_id', tag: 'select', options: [] }
      ],
      tableConfig: [
        { prop: 'pay_status', label: '缴费状态' },
        { prop: 'student_name', label: '学生姓名' },
        { prop: 'school_name', label: '报名校区' },
        { prop: 'grade_name', label: '入学年级' },
        { prop: 'exam_name', label: '计算分差费考试名称' },
        { prop: 'city_name', label: '参考城市' },
        { prop: 'total_score', label: '考试总分' },
        { prop: 'convert_score', label: '折算后考试总分' },
        { prop: 'sys_compute_fee', label: '系统计算待缴分差费总额' },
        { prop: 'teacher_name', label: '招生老师' },
        { label: '操作', width: '100rem', handle: true }
      ]
    }
  },
  created() {
    this.getConfig()
  },
  methods: {
    getConfig() {
      getAllUnDeleteGrade().then(res => {
        setConfigOption({ list: this.searchConfig, data: res, key: 'grade_id' })
      })
      getActualSchool().then(res => {
        setConfigOption({ list: this.searchConfig, data: res, key: 'school_id' })
      })
    },
    getData() {
      this.getDataApi('/zhaosheng/api/finance/order-diff-fee/list')
    },
    handDownload() {
      fileDownload('/zhaosheng/api/finance/order-diff-fee/export', {...this.search}, { name: '分差费缴纳审批', show: true })
    },
    handleClick(row, handle) {
      const { id, off_line_pay_id, order_pay_status } = row
      const { type } = handle
      if (type  === 'approve') {
        if (off_line_pay_id && order_pay_status === 0) {
          return this.$msgbox({
            title: '注意',
            message: '该学生学费仍在【线下支付审批】待审批状态，缴纳学费后才能缴纳分差费哦！',
            confirmButtonText: '去审批',
            beforeClose: (action, instance, done) => {
              done()
              if (action === 'confirm') {
                this.$router.push(`/finance/enrollment/offline-payment-approval/edit?id=${off_line_pay_id}`)
              }
            }
          })
        }
        this.$router.push(`./edit?id=${id}`)
      } else if (type === 'view') {
        this.$router.push(`./detail?id=${id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
